<template>
  <div ref="container" style="background:#F8F8F8;height:100%">
    <div class="searchGood">
      <div class="search acea-row row-between-wrapper">
        <div class="input acea-row row-between-wrapper">
          <span class="iconfont icon-sousuo2"></span>
          <form @submit.prevent="submit"></form>
          <input type="text" placeholder="点击搜索商品" v-model="search" />
        </div>
        <div class="bnt" @click="submit">搜索</div>
      </div>
      <div class="hot" v-if="keywords.length">
        <div class="hot-title">
          <div class="hot-title-left">热门搜索</div>
          <!-- <div class="hot-title-right">清空历史</div> -->
        </div>
        <div class="content">
          <div
            class="li"
            v-for="key of keywords"
            :key="key"
            @click="toSearch(key)"
          >
            {{ key }}
          </div>
        </div>
      </div>
      <div class="hot" style="margin-top:15px" v-if="historyList.length > 0">
        <div class="hot-title">
          <div class="hot-title-left">最近搜索</div>
          <div class="hot-title-right" @click="clear">清空历史</div>
        </div>
        <div class="content">
          <div
            class="li"
            v-for="(item, index) in historyList"
            :key="index"
            @click="toSearch(item)"
          >
            {{ item }}
          </div>
        </div>
      </div>
      <div class="line"></div>
      <GoodList :goodList="goodList" :isSort="false"></GoodList>
      <Loading
        :loaded="loadend"
        :loading="loading"
        v-if="goodList.length"
      ></Loading>
    </div>
    <div
      class="noCommodity"
      v-cloak
      v-if="goodList.length === 0 && where.page > 1"
    >
      <div class="noPictrue">
        <img src="@assets/images/noSearch.png" class="image" />
      </div>
      <recommend></recommend>
    </div>
  </div>
</template>
<script>
import Loading from "@components/Loading";
import GoodList from "@components/GoodList";
import { getSearchKeyword } from "@api/store";
import { trim } from "@utils";
import { getProducts } from "@api/store";
import Recommend from "@components/Recommend";
export default {
  name: "GoodSearch",
  components: {
    GoodList,
    Loading,
    Recommend
    // Recommend,
    // GoodList
  },
  props: {},
  data: function() {
    return {
      keywords: [],
      search: "",
      where: {
        page: 1,
        limit: 20,
        keyword: ""
      },
      loading: false,
      loadend: false,
      goodList: [],
      historyList: []
    };
  },
  mounted: function() {
    this.getData();
    this.$scroll(this.$refs.container, () => {
      console.log(123);
      !this.loading && this.getGoodlist();
    });
  },
  methods: {
    submit() {
      const search = trim(this.search) || "";
      if (!search) return;
      this.where.keyword = search;
      // this.$set(this, "goodList", []);
      // this.where.page = 1;
      // this.loadend = false;
      // this.loading = false;
      // this.getGoodlist();
      this.$router.push({
        path: "goods_list",
        query: {
          title: search,
          type: "search"
        }
      });
    },
    // toSearch(s) {
    //   this.$router.push({ path: "/goods_list", query: { s } });
    // },
    getData() {
      getSearchKeyword().then(res => {
        this.keywords = res.data;
        let historyList =
          JSON.parse(localStorage.getItem("historyList")) || [];
          this.historyList=historyList.filter((x) => x !== '');
      });
     
    },
    /**清空历史记录 */
    clear() {
      this.historyList = [];
      localStorage.removeItem("historyList");
    },
    toSearch: function(key) {
      this.where.keyword = key;
      this.$router.push({
        path: "goods_list",
        query: {
          title: key,
          type: "search"
        }
      });
      // this.$set(this, "goodList", []);
      // this.where.page = 1;
      // this.loadend = false;
      // this.loading = false;
      // this.getGoodlist();
    },
    getGoodlist: function() {
      let that = this;
      if (that.loading) return; //阻止下次请求（false可以进行请求）；
      if (that.loadend) return; //阻止结束当前请求（false可以进行请求）；
      that.loading = true;
      let q = that.where;
      getProducts(q).then(res => {
        that.loading = false;
        that.goodList.push.apply(that.goodList, res.data);
        that.loadend = res.data.length < that.where.limit; //判断所有数据是否加载完成；
        that.where.page = that.where.page + 1;
      });
    }
  }
};
</script>
<style scoped>
.noCommodity {
  border-top: 0.05rem solid #f5f5f5;
}
.searchGood .search {
  background: #d01112;
  margin-top: 0;
  height: 44px;
  line-height: 44px;
}
.searchGood .search .bnt {
  color: #fff;
}
.searchGood .search .input {
  line-height: 0.66rem;
}
.hot {
  margin: 0 13px;
  min-height: 53px;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0px 1px 15px 0px rgba(157, 157, 157, 0.2);
  margin-top: 17px;
}
.hot .hot-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  height: 53px;
}
.hot .hot-title .hot-title-left {
  font-size: 16px;
  color: #333333;
}
.hot .hot-title .hot-title-right {
  color: #999999;
  font-size: 12px;
}
.hot .content {
  margin: 0 20px;
  display: flex;
  flex-wrap: wrap;
}
.hot .content .li {
  padding: 0 12px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  background: #faf7f7;
  color: #333333;
  font-size: 14px;
  border-radius: 16px;
  width: fit-content;
  margin-right: 15px;
  margin-bottom: 18px;
}
</style>
